import React from 'react';
import '../styles/serviceConfigStyles.css';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import CircleIcon from '@mui/icons-material/Circle';
import { ButtonGroup } from '@mui/material';  
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { API } from 'aws-amplify';

// Button custom colors
import { ThemeProvider, createTheme } from "@mui/material/styles";
const theme = createTheme({
  palette: {
    violetButton: {
       main: "#6a5acd",
       contrastText: "#000",
    },
  }
});

const myAPI = "api94d03d7c";
const primaryServerStatusPath = "/get-primary-server-status";
const guiStatusPath = "/get-gui-status";
const rebootPath = "/reboot-sienna-server";
const startPath = "/start-sienna-server";
const stopPath = "/stop-sienna-server";
const primaryInstanceId = "i-03e1a6181fd075676"
const secondaryInstanceId = "i-0c7d42157cfe64d9a"


export default function ServiceConfiguration (){

    // State vals
    const [isGUIRunning1, setIsGUIRunning1] = useState(true);
    const [isServerRunning1, setIsServerRunning1] = useState(false);
    
    const [isGUIRunning2, setIsGUIRunning2] = useState(false);
    const [isServerRunning2, setIsServerRunning2] = useState(false);
    

    const guiCircleStyle1 = {
        color: isGUIRunning1 ? '#387F17' : 'black',
        marginRight: '20px'
    };
    const serverCircleStyle1 = {
        color: isServerRunning1 ? '#387F17' : 'black',
    };


    const guiCircleStyle2 = {
        color: isGUIRunning2 ? '#387F17' : 'black',
        marginRight: '20px'
    };
    const serverCircleStyle2 = {
        color: isServerRunning2 ? '#387F17' : 'black'
    };

  // Get primary server status
  function getPrimaryServerStatus() {
    const event_body = {
      "queryStringParameters": {
        // "instance_id": "i-023e19a0871973ff3",
        "instance_id": primaryInstanceId,
      }
    };
    API.get(myAPI, primaryServerStatusPath, event_body)
      .then(response => {
        console.log(response, event_body["queryStringParameters"]["instance_id"])
        if(response === "running") {
            setIsServerRunning1(true)
        }
        else {
            setIsServerRunning1(false)
        }
      })
      .catch(error => {
        console.log("In error section", error)
      })
  }
  useEffect(() => {
    getPrimaryServerStatus();
  }, []);

  // Get primary GUI status
  function getPrimaryGuiStatus() {
    const event_body = {
      "queryStringParameters": {
        "server_ip": "44.225.79.6",
      }
    };
    API.get(myAPI, guiStatusPath, event_body)
      .then(response => {
        console.log(response, event_body["queryStringParameters"]["server_ip"])
        if(response === "200" || response === "403") {
            setIsGUIRunning1(true)
        }
        else {
            setIsGUIRunning1(false)
        }
      })
      .catch(error => {
        console.log("In error section", error)
      })
  }
  useEffect(() => {
    getPrimaryGuiStatus();
  }, []);

  // Get secondary server status
  function getSecondaryServerStatus() {
    const event_body = {
      "queryStringParameters": {
        "instance_id": secondaryInstanceId,
        // "instance_id": "i-023e19a0871973ff3",
      }
    };
    API.get(myAPI, primaryServerStatusPath, event_body)
      .then(response => {
        console.log(response, event_body["queryStringParameters"]["instance_id"])
        if(response === "running") {
            setIsServerRunning2(true)
        }
        else {
            setIsServerRunning2(false)
        }
      })
      .catch(error => {
        console.log("In error section", error)
      })
  }
  useEffect(() => {
    getSecondaryServerStatus();
  }, []);

  // Get secondary GUI status
  function getSecondaryGuiStatus() {
    const event_body = {
      "queryStringParameters": {
        "server_ip": "18.236.168.53",
      }
    };
    API.get(myAPI, guiStatusPath, event_body)
      .then(response => {
        console.log(response, event_body["queryStringParameters"]["server_ip"])
        if(response === "200" || response === "403") {
            setIsGUIRunning2(true)
        }
        else {
            setIsGUIRunning2(false)
        }
      })
      .catch(error => {
        console.log("In error section", error)
      })
  }
  useEffect(() => {
    getSecondaryGuiStatus();
  }, []);

  function handleReboot(id) {
      const event_body = {
          "body": {
              "instance_id": id
          }
      }
      API.post(myAPI, rebootPath, event_body)
        .then(response => {
            console.log(response)
        })
        .catch(error => {
            console.log(error)
        })
    }

    function handleServerStop(id) {
        const event_body = {
            "body": {
                "instance_id": id
            }
        }
        API.post(myAPI, stopPath, event_body)
          .then(response => {
              console.log(response)
          })
          .catch(error => {
              console.log(error)
          })
      }


      function handleServerStart(id) {
        const event_body = {
            "body": {
                "instance_id": id
            }
        }
        API.post(myAPI, startPath, event_body)
          .then(response => {
              console.log(response)
          })
          .catch(error => {
              console.log(error)
          })
      }

    return (
        <ThemeProvider theme={theme}>
        <div className="sienna-border">
            <p className="sienna-title">SIENNA</p>
            <div className="server-box">
                <div>
                    <ul className="server-box-format">
                        <p className="server-ip">Server IP - 44.225.79.6</p>
                        <div className="server-status">
                            <ul className="icon-spacing">
                                <p className="status-spacing">GUI STATUS:</p>
                                <CircleIcon style={guiCircleStyle1}/>
                                <p className="status-spacing">Server STATUS:</p>
                                <CircleIcon style={serverCircleStyle1}/>
                            </ul>
                        </div>
                        <div className="server-action-icons">
                            <ButtonGroup>
                            <Button size="small" variant="contained" color="violetButton"
                            onClick={() => handleServerStop(primaryInstanceId)}>
                                    <Tooltip title="Stop server">
                                        <StopCircleOutlinedIcon className="action-icon-button-format"></StopCircleOutlinedIcon>
                                    </Tooltip>
                                </Button>
                                <Button size="small" variant="contained" color="violetButton"
                                onClick={() => handleServerStart(primaryInstanceId)}>
                                    <Tooltip title="Start server">
                                        <PlayCircleFilledWhiteOutlinedIcon className="action-icon-button-format"></PlayCircleFilledWhiteOutlinedIcon>
                                    </Tooltip>
                                </Button>
                                <Button size="small" variant="contained" color="violetButton"
                                onClick={() => handleReboot(primaryInstanceId)}>
                                    <Tooltip title="Reboot server">
                                        <RefreshOutlinedIcon className="action-icon-button-format"></RefreshOutlinedIcon>
                                    </Tooltip>
                                </Button>
                            </ButtonGroup>
                        </div>
                    </ul>
                </div>
            </div>
            <div className="server-box">
                <div>
                    <ul className="server-box-format">
                        <p className="server-ip">Server IP - 18.236.168.53</p>
                        <div className="server-status">
                            <ul className="icon-spacing">
                                <p className="status-spacing">GUI STATUS:</p>
                                <CircleIcon style={guiCircleStyle2}/>
                                <p className="status-spacing">Server STATUS:</p>
                                <CircleIcon style={serverCircleStyle2}/>
                            </ul>
                        </div>
                        <div className="server-action-icons">
                            <ButtonGroup>
                                <Button size="small" variant="contained" color="violetButton"
                                onClick={() => handleServerStop(secondaryInstanceId)}>
                                    <Tooltip title="Stop server">
                                        <StopCircleOutlinedIcon className="action-icon-button-format"></StopCircleOutlinedIcon>
                                    </Tooltip>
                                </Button>
                                <Button size="small" variant="contained" color="violetButton"
                                onClick={() => handleServerStart(secondaryInstanceId)}>
                                    <Tooltip title="Start server">
                                        <PlayCircleFilledWhiteOutlinedIcon className="action-icon-button-format"></PlayCircleFilledWhiteOutlinedIcon>
                                    </Tooltip>
                                </Button>
                                <Button size="small" variant="contained" color="violetButton" 
                                onClick={() => handleReboot(secondaryInstanceId)}>
                                    <Tooltip title="Reboot server">
                                        <RefreshOutlinedIcon className="action-icon-button-format"></RefreshOutlinedIcon>
                                    </Tooltip>
                                </Button>
                            </ButtonGroup>
                        </div>
                    </ul>
                </div>
            </div>
        </div>
        </ThemeProvider>
    )
}
  

